(function () {
    'use strict';

    angular
        .module('riskModule')
        .directive('showRiskAssessmentRatingsLegend', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
            },
            controller: ['$scope', '$modal', function ($scope, $modal) {

                $scope.showLegend = function () {

                    // Modal to show
                    var modalScope = $scope.$new(true);

                    var showModal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/risk/showRiskAssessmentRatingsLegend.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        showModal.$promise.then(showModal.hide);
                    }

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    }
                };
            }],
            link: function (scope, elem, attrs) {

                elem.bind('click', function () {
                    scope.showLegend();
                });
            }
        }
    }
})();